import React, { FC, useEffect, useRef, useState } from "react";
import { Button, Table, Input, message, Upload, Checkbox, Tooltip, notification, Image } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatInt, formatNum, formatDiscount } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ISCMSDcGoodsDetail } from "../../assetsClearTypes";
import { useAssetsClearDetailsModel } from "./assetsClearDetailsModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { CloseOutlined, ExclamationCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { warehouseService } from "@/views/base/warehouseManage/warehouseService";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { assetsEntryService } from "@/views/manage/assetsEntry/assetsEntryService";
import { assetsClearService } from "../../assetsClearService";
import { importPropsConfig } from "@/utils/importFile";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import YhTootip from "@/components/YhTootip";
type ISCMSDcGoodsSearch = {
    data: ISCMSDcGoodsDetail[],
    isSearch: boolean
}

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { warehouseList, setLoadingInfo, shopAndOrg, userData, fetchUserList } = useGlobalModel();
    const { getSelectedDictValueOne, getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
    const { addGoodsList, addFormVal, editFormVal, editFormVal: { status }, setHistoryVisible, historyRow, historyVisible, setButtonControl,
        setHistoryRow, setAddGoodsList, editGoodsList, setEditGoodsList, setSaveBtn, setAddGoodsModal, downloadTpl, transformsToSDcGoods, changeImport, setChangeImport } = useAssetsClearDetailsModel();
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [searchParms, setSearchParms] = useState<string>("");
    const [searchVal, setSearchVal] = useState<ISCMSDcGoodsSearch>({ data: [], isSearch: false });   //用于搜索展示的数据
    const [selectedRowRows, setSelectedRowRows] = useState<any>([]);
    const formRef = useRef<any>()
    //删除商品
    const onRemove = () => {
        if (!selectedRowKeys.length) {
            message.warning("请选择你要删除的商品");
            return;
        }
        mode === "edit" ?
            setEditGoodsList(origin => origin.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0)) :
            setAddGoodsList(origin => origin.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0));

        let newSearchData = searchVal.data.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0)
        setSearchVal({ data: newSearchData, isSearch: searchVal.isSearch });
        mode === "add" ? setButtonControl(false) : setButtonControl(true)
        setSelectedRowKeys([]);
        message.success("删除成功");
    }
    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false, txt: '' })
        if (list && list.length) {
            let str = ""
            let name = mode == 'add' ? addFormVal.departmentName : editFormVal.departmentName
            list.map((list, index) => {
                if (list.status) {
                    transformsToSDcGoods(list.details, mode, 'import')
                }
                else {
                    str += `【第${index + 1}条导入失败：${list.msg}】`;
                }
            })
            str ? notification.warning({ message: '提醒', description: str, duration: 15 }) : message.success("导入成功")
        }
    }





    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<any>([]);
    const changeshelfCode = async (value, options) => {
        let newRecords: any = []
        let params = {
            pageSize: 99999,
            pageNum: 1,
            ...shopAndOrg,
            warehouseId: warehouseList.find((item) => item.value === value.warehouseCode)?.id,
            warehouseCode: value.warehouseCode,
            enable: "1"
        }
        const { retData: shelfAll } = await warehouseService.shelfAllPage(params)
        newRecords = shelfAll.map((item) => { return { ...item, label: (item.code as string), value: item.code, } })
        setShelfAllList(newRecords);
    }
    //搜索  前端自己保存搜索的值， 搜索值为空还是用缓存
    const goodsFilter = (dataSource: ISCMSDcGoodsDetail[] | null = null) => {
        const isEtit = mode !== "add";
        let goodsList = dataSource ? dataSource : [...(isEtit ? editGoodsList : addGoodsList)];
        if (searchParms) {
            let reg = new RegExp(searchParms);
            let arr: any = [];
            goodsList.forEach(item => {
                if (item.materialCode?.match(reg) || item.materialName?.match(reg)) {
                    arr.push(item);
                }
            })
            setSearchVal({ data: arr, isSearch: true });

            if (!arr.length) {
                message.warning("列表没有该商品！！")
                setSearchVal({ data: [], isSearch: false });
            }
        } else {
            setSearchVal({ data: [], isSearch: false });
        }
    }
    const onfocusUserCode = () => {
        fetchUserList(mode == 'add' ? addFormVal.department : editFormVal.department)
    }
    const dataSourse = mode === 'add' ? addFormVal : editFormVal
    // 新增
    const onAdd = () => {
        if (!dataSourse.materialTypeCode) {
            setAddGoodsModal(false)
            return message.warning('请先选择物料类别！')
        } else {
            setAddGoodsModal(true)
        }
    }

    const action = <div className="flex justify-between white-space">
        <div>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_S_ED_AD}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onAdd}
                    disabled={!(mode == 'add')}
                >新增物品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_S_ED_DEL}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => onRemove()}
                    disabled={!(mode == 'add')}
                >删除物品</Button>
            </YhAuth>
        </div>
        <div className="flex">
            <Input
                size="small"
                allowClear
                datatype="round"
                className="border-r-8 ml-10"
                placeholder="物资编号/物资名称"
                onChange={(e) => { setSearchParms(e.target.value) }}
                onBlur={(e) => setSearchParms(e.target.value?.trim())}
            // onPressEnter={() => goodsFilter()}
            />
            <Button type="primary" style={{ margin: "0px 12px 0px 15px" }} shape="round" onClick={() => goodsFilter()}> 查询</Button>
        </div>
    </div>;


    const columns = [
        {
            title: '序号',
            width: 50,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '物资图片',
            width: 140,
            align: "center",
            fixed: "left",
            render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} /> : null)
        }, {
            title: '物资编码',
            width: 180,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: "left",
        }, {
            title: '物资类型',
            width: 100,
            dataIndex: 'typeCode',
            render: (text: string) => getTreeNodeName(text) ?? ''
        }, {
            title: '规格型号',
            width: 130,
            dataIndex: 'model',
            render: (text: string) => <YhTootip text={text} />,
        }, {
            title: '单位',
            width: 80,
            dataIndex: 'unitCode',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',
        }, {
            title: '数量',
            width: 90,
            dataIndex: 'num',
        }, {
            title: '所属部门',
            width: 140,
            dataIndex: 'departmentName',
        },
        {
            title: '仓库',
            width: 130,
            dataIndex: 'warehouseName',
        },
        {
            title: '货位',
            width: 130,
            dataIndex: 'shelfCode',
        },
        {
            title: '报废单号',
            width: 100,
            dataIndex: 'receiveCode',
        },
    ];

    const newSelectColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col?.rules,
                options: col?.options,
                editType: col?.editType,
                editable: mode == 'look' ? false : col?.editable,
                onSelectChange: col?.onSelectChange,
                onSelectFocus: col?.onSelectFocus,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
                allowClear: col.allowClear,
            }),
        }
    })

    //内联编辑   (计算价格)
    const handleSave = (row: ISCMSDcGoodsDetail) => {

        let dataSource = mode === "edit" ? editGoodsList : addGoodsList
        const index = dataSource.findIndex((item) => row.temporaryId ? row.temporaryId === item.temporaryId : row.detailsId === item.detailsId);
        const item = dataSource[index];
        if (row.changeFields == "warehouseCode") {
            row.warehouseName = warehouseList.find((item) => item.value === row.warehouseCode)?.label
            row.shelfCode = ""
        }
        if (row.changeFields == "userCode") {
            row.user = userData.find((item) => item.value === row.userCode)?.label
        }
        dataSource.splice(index, 1, { ...item, ...row });
        mode === "edit" ? setEditGoodsList([...dataSource]) : setAddGoodsList([...dataSource]);
        //判断展示的是搜索后的数据，然后搜索的也改变
        if (searchVal.isSearch) {
            goodsFilter(dataSource)
        }
        setButtonControl(true)
        setSaveBtn(true)
    }

    return (
        <YhBox title="" action={action} style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.temporaryId}
                rowClassName={(record) => {
                    if (!record?.isHave || record.error) return "editable-row yh-edit-table-tr background-FFB4B4";
                    return "editable-row yh-edit-table-tr"
                }}
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMSDcGoodsDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                        setSelectedRowRows(selectedRows)
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                bordered
                columns={newSelectColumns as ColumnsType<ISCMSDcGoodsDetail>}
                dataSource={searchVal.isSearch ? searchVal.data : mode === "add" ? addGoodsList : editGoodsList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}